<!--banner-->
<section class="hero" id="hero">
    <div class="container mx-auto px-2.5 sm:px-4">
        <div class="content mx-auto max-w-3xl">
            <h3 class="animated-text">
                West Bengal State Rural Livelihoods Mission (WBSRLM)
                <br>
                <span class="brand-highlight animate-pulse">– WBSRLM</span>
            </h3>
            <!-- <p
                class="hero-tagline text-gray-100 mt-2 sm:mt-2.5 text-xs sm:text-sm md:text-base max-w-xl mx-auto font-light leading-snug">
                Empowering rural women through community institutions, sustainable livelihoods, and structured capacity
                building.
            </p> -->
            <div class="hero-actions mt-2.5 sm:mt-3.5 flex flex-wrap items-center justify-center gap-2 sm:gap-2.5">
                <!-- <a (click)="smoothScroll('about-us')" class="btn-hero-primary cursor-pointer inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-md text-white font-medium text-xs sm:text-sm bg-[#f49054] hover:bg-[#e07d3f] transition-all shadow-sm">
                    <span>Learn More</span>
                    <i class="material-symbols-outlined !text-[16px]">arrow_downward</i>
                </a> -->
                <a routerLink="/authentication"
                    class="btn-hero-outline inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-md text-white font-medium text-xs sm:text-sm border border-white/80 hover:bg-white/10 transition-all backdrop-blur-xs">
                    <span>Sign in to Portal</span>
                    <i class="material-symbols-outlined !text-[16px]">login</i>
                </a>
            </div>
        </div>
    </div>
</section>


<!--aboutus-->
<div class="about-us" id="about-us">
    <div class="container mx-auto px-2.5 sm:px-4">
        <div class="row align-items-center">
            <div class="col-12 col-lg-7">
                <h5 class="section-title text-[#f49054] font-bold text-lg sm:text-xl mb-1.5">About WBSRLM
                </h5>
                <p class="text-gray-700 leading-normal text-xs sm:text-sm mb-1.5">
                    West Bengal State Rural Livelihoods Mission, popularly known WBSRLM, is the State Rural
                    Livelihoods Mission of West Bengal. It functions under the framework of the National Rural
                    Livelihoods Mission (NRLM) with the core objective of reducing rural poverty through women-led
                    institutional platforms.
                </p>
                <h6 class="font-semibold text-gray-900 mt-1.5 mb-1 text-xs sm:text-sm">
                    The Mission works by:
                </h6>
                <ul class="custom-bullet-list text-gray-700 text-xs sm:text-sm pl-4 space-y-0.5 mb-1.5">
                    <li>Organizing rural poor women into Self Help Groups (SHGs)</li>
                    <li>Federating SHGs into Sangha Samabays or Cluster Level Federations (CLFs)</li>
                    <li>Strengthening access to financial services</li>
                    <li>Promoting sustainable livelihoods</li>
                    <li>Enhancing social inclusion and gender empowerment</li>
                </ul>
                <p class="text-gray-700 leading-normal text-xs sm:text-sm m-0">
                    WBSRLM focuses on building strong community institutions that are self-reliant, transparent,
                    and sustainable.
                </p>
            </div>
            <div class="col-12 col-lg-5 mt-2.5 lg:mt-0">
                <div id="carouselExampleIndicators" class="carousel slide rounded-lg overflow-hidden shadow-sm"
                    data-ride="carousel">
                    <ol class="carousel-indicators">
                        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
                    </ol>
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img class="d-block w-100" src="../../../../../../assets/images/img/tms-slide-1.jpg"
                                alt="WBSRLM Training Session">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block w-100" src="../../../../../../assets/images/img/tms-slide-2.jpg"
                                alt="WBSRLM Capacity Building">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block w-100" src="../../../../../../assets/images/img/tms-slide-3.jpg"
                                alt="WBSRLM Skill Development">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block w-100" src="../../../../../../assets/images/img/tms-slide-4.jpg"
                                alt="WBSRLM Community Workshop">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Mission & Vision -->
<section class="mission-vision-section" id="mission-vision">
    <div class="container mx-auto px-2.5 sm:px-4">
        <div class="row">
            <div class="col-12 text-center mb-2.5 sm:mb-2.5">
                <h5 class="text-gray-900 font-bold text-lg sm:text-xl m-0">Our Mission & Vision</h5>
                <div class="w-10 h-0.5 bg-[#f49054] mx-auto mt-1 rounded-full"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 mb-2 sm:mb-2.5 md:mb-0">
                <div class="mv-card mission-card h-100 border-l-[4px] border-l-sky-600">
                    <h6 class="text-sky-700 font-bold text-sm sm:text-base mb-1">Mission of WBSRLM</h6>
                    <p class="text-gray-700 leading-normal text-xs sm:text-sm mb-1">
                        To reduce poverty by enabling the poor households to access gainful self-employment and skilled
                        wage employment opportunities, resulting in appreciable improvement in their livelihoods on a
                        sustainable basis through strong institutional platforms of the poor.
                    </p>
                    <ul class="custom-bullet-list text-gray-700 text-xs sm:text-sm pl-4 space-y-0.5 m-0">
                        <li>Social mobilization and institution building</li>
                        <li>Financial inclusion</li>
                        <li>Livelihood promotion</li>
                        <li>Capacity enhancement</li>
                        <li>Convergence with government schemes</li>
                        <li>Women empowerment and social development</li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="mv-card vision-card h-100 border-l-[4px] border-l-amber-500">
                    <h6 class="text-amber-600 font-bold text-sm sm:text-base mb-1">Vision of WBSRLM</h6>
                    <p class="text-gray-700 leading-normal text-xs sm:text-sm mb-1">
                        To create a self-reliant, empowered, and economically secure rural society led by strong women
                        institutions.
                    </p>
                    <ul class="custom-bullet-list text-gray-700 text-xs sm:text-sm pl-4 space-y-0.5 m-0">
                        <li>Universal social mobilization</li>
                        <li>Sustainable livelihoods for every rural poor household</li>
                        <li>Financial independence of SHGs</li>
                        <li>Digitally empowered community institutions</li>
                        <li>Gender-equitable rural development</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Training & Capacity Building (T&CB) -->
<section class="mission-vision-section bg-white">
    <div class="container mx-auto px-2.5 sm:px-4">
        <div class="row">
            <div class="col-12 text-center mb-2 sm:mb-2.5">
                <h5 class="text-gray-900 font-bold text-lg sm:text-xl m-0">Training & Capacity Building (T&CB) under
                    WBSRLM</h5>
                <div class="w-10 h-0.5 bg-green-600 mx-auto mt-1 rounded-full"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 mb-2 sm:mb-2.5 md:mb-0">
                <div class="mv-card mission-card h-100 border-l-[4px] border-l-green-700">
                    <h6 class="text-green-700 font-bold text-sm sm:text-base mb-1">Importance of Training & Capacity
                        Building</h6>
                    <p class="text-gray-700 leading-normal text-xs sm:text-sm mb-1">
                        Training & Capacity Building is the backbone of WBSRLM. Since the Mission is based on
                        community-led development, strengthening knowledge, skills, and leadership among members is
                        essential.
                    </p>
                    <p class="text-gray-900 font-semibold mb-1 text-xs sm:text-sm">T&CB ensures:</p>
                    <ul class="custom-bullet-list text-gray-700 text-xs sm:text-sm pl-4 space-y-0.5 m-0">
                        <li>Institutional sustainability</li>
                        <li>Improved governance and transparency</li>
                        <li>Financial discipline</li>
                        <li>Enhanced livelihood productivity</li>
                        <li>Leadership development among rural women</li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="mv-card vision-card h-100 border-l-[4px] border-l-blue-800">
                    <h6 class="text-blue-800 font-bold text-sm sm:text-base mb-1">Objectives of Training & Capacity
                        Building</h6>
                    <ul class="custom-bullet-list text-gray-700 text-xs sm:text-sm pl-4 space-y-0.5 m-0">
                        <li>To enhance functional literacy and awareness among SHG members</li>
                        <li>To strengthen governance of SHGs, Sanghas, and CLFs</li>
                        <li>To build financial management skills</li>
                        <li>To promote entrepreneurship and livelihood diversification</li>
                        <li>To develop Community Resource Persons (CRPs)</li>
                        <li>To ensure effective implementation of Mission interventions</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Major Areas of Training -->
<section class="mission-vision-section" id="training-areas">
    <div class="container mx-auto px-2.5 sm:px-4">
        <div class="row">
            <div class="col-12 text-center mb-2 sm:mb-2.5">
                <h5 class="text-gray-900 font-bold text-lg sm:text-xl m-0">Major Areas of Training</h5>
                <div class="w-10 h-0.5 bg-sky-600 mx-auto mt-1 rounded-full"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 mb-2 sm:mb-2.5">
                <div class="mv-card1 mission-card h-100">
                    <h6 class="card-title1 text-sky-700 font-bold text-sm mb-1">A. Social Mobilization & Institution
                        Building</h6>
                    <ul class="custom-bullet-list text-gray-700 text-xs sm:text-sm pl-4 space-y-0.5 m-0">
                        <li>SHG concept and norms</li>
                        <li>Roles & responsibilities of office bearers</li>
                        <li>Meeting management</li>
                        <li>Bookkeeping practices</li>
                        <li>Federation management</li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-md-6 mb-2 sm:mb-2.5">
                <div class="mv-card1 mission-card h-100">
                    <h6 class="card-title1 text-sky-700 font-bold text-sm mb-1">B. Financial Inclusion & Management</h6>
                    <ul class="custom-bullet-list text-gray-700 text-xs sm:text-sm pl-4 space-y-0.5 m-0">
                        <li>Bank linkage process</li>
                        <li>Credit planning and loan management</li>
                        <li>Community Investment Fund (CIF) management</li>
                        <li>Vulnerability Reduction Fund (VRF) management</li>
                        <li>Financial literacy and digital transactions</li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-lg-4 col-md-6 mb-2 sm:mb-2.5">
                <div class="mv-card1 mission-card h-100">
                    <h6 class="card-title1 text-sky-700 font-bold text-sm mb-1">C. Livelihood Promotion & Market Linkage
                    </h6>
                    <ul class="custom-bullet-list text-gray-700 text-xs sm:text-sm pl-4 space-y-0.5 m-0">
                        <li>Farm-based livelihood enhancement</li>
                        <li>Non-farm enterprises promotion</li>
                        <li>Micro-enterprise development</li>
                        <li>Business planning and market linkage & Convergence</li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-lg-4 col-md-6 mb-2 sm:mb-2.5">
                <div class="mv-card1 mission-card h-100">
                    <h6 class="card-title1 text-sky-700 font-bold text-sm mb-1">D. Skill Development</h6>
                    <ul class="custom-bullet-list text-gray-700 text-xs sm:text-sm pl-4 space-y-0.5 m-0">
                        <li>Vocational skill training</li>
                        <li>Value addition and processing</li>
                        <li>Packaging and branding</li>
                        <li>Quality control</li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-lg-4 col-md-12 mb-2 sm:mb-2.5">
                <div class="mv-card1 mission-card h-100">
                    <h6 class="card-title1 text-sky-700 font-bold text-sm mb-1">E. Leadership & Social Development</h6>
                    <ul class="custom-bullet-list text-gray-700 text-xs sm:text-sm pl-4 space-y-0.5 m-0">
                        <li>Gender sensitization</li>
                        <li>Social action planning</li>
                        <li>Conflict resolution</li>
                        <li>Community leadership development</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Institutional Structure for T&CB -->
<section class="mission-vision-section bg-white">
    <div class="container mx-auto px-2.5 sm:px-4">
        <div class="row">
            <div class="col-12 col-md-6 mb-2 sm:mb-2.5 md:mb-0">
                <div class="mv-card mission-card h-100 border-l-[4px] border-l-lime-700">
                    <h6 class="text-lime-700 font-bold text-sm sm:text-base mb-1">Institutional Structure for T&CB</h6>
                    <p class="text-gray-900 font-semibold mb-1 text-xs sm:text-sm">Training is implemented through:</p>
                    <ul class="custom-bullet-list text-gray-700 text-xs sm:text-sm pl-4 space-y-0.5 m-0">
                        <li>State Mission Management Unit (SMMU)</li>
                        <li>District Mission Management Units (DMMU)</li>
                        <li>Block Mission Management Units (BMMU)</li>
                        <li>Community Managed Training Centres (CMTCs)</li>
                        <li>Community Resource Persons (CRPs)</li>
                        <li>External resource agencies</li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="mv-card vision-card h-100 border-l-[4px] border-l-amber-800">
                    <h6 class="text-amber-800 font-bold text-sm sm:text-base mb-1">Expected Outcomes of T&CB</h6>
                    <ul class="custom-bullet-list text-gray-700 text-xs sm:text-sm pl-4 space-y-0.5 m-0">
                        <li>Strong and self-managed SHGs</li>
                        <li>Financially disciplined federations</li>
                        <li>Increased income and livelihood diversification</li>
                        <li>Enhanced participation of women in decision-making</li>
                        <li>Sustainable and accountable community institutions</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Conclusion -->
<section class="mission-vision-section bg-white py-2 sm:py-3">
    <div class="container mx-auto px-2.5 sm:px-4">
        <div class="row">
            <div class="col-12 text-center max-w-2xl mx-auto">
                <h5 class="text-gray-900 font-bold text-lg sm:text-xl mb-1.5">Conclusion</h5>
                <div class="w-10 h-0.5 bg-[#f49054] mx-auto mb-2 rounded-full"></div>
                <p class="text-gray-700 leading-normal text-xs sm:text-sm mb-1.5">
                    WBSRLM envisions a transformed rural society led by empowered women institutions.
                    Training & Capacity Building plays a pivotal role in achieving this transformation by equipping
                    rural women with the skills, knowledge, and confidence required to manage institutions and
                    livelihoods effectively.
                </p>
                <p class="text-gray-700 leading-normal text-xs sm:text-sm m-0">
                    Through structured capacity enhancement and institutional strengthening, WBSRLM continues to
                    move towards inclusive, sustainable, and women-led rural development in West Bengal.
                </p>
            </div>
        </div>
    </div>
</section>